exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-sanity-page-slug-current-jsx": () => import("./../../../src/pages/{SanityPage.slug__current}.jsx" /* webpackChunkName: "component---src-pages-sanity-page-slug-current-jsx" */)
}

